export default __webpack_public_path__ + "static/media/horse-realistic-2.4733107a.svg";